<template>
<!-- 文章集锦 -->
  <div>
    <div id="articalCollections" v-if="showPage">
      <div class="top-header">
        <div class="header-bg">
          <div class="search">
            <i class="icon iconfont iconsousuo search-icon"></i>
            <input @focus="searchHandler" class="allInput searchBar" type="text" style="padding: 0 30px 0 33px!important;">
            <i class="icon iconfont iconguanbi empty-icon"></i>
          </div>
          <div :class="{'top-menu': true, 'top-menu-active': showHeadMenu}" @click="toggleHeadMenu">
            <i :class="{'icon':true, 'iconfont':true, 'iconhanbaocaidan': true, 'menu-icon':true, 'menu-icon-active': showHeadMenu}" style="font-size: 20px!important;"></i>
            <!-- 隐藏菜单 -->
            <div v-show="showHeadMenu" class="top-menu-list">
              <!-- <div style="" @click="goFavoritesPage">
                <i class="icon iconfont iconshuqian" style="color: #E71222;"></i>
                <span style="margin-left: 5px;font-size: 14px;">我的收藏</span>
              </div> -->
              <div style="" @click="goPersonalPage">
                <i class="icon iconfont icongerenzhongxin1" style="color: #E71222;"></i>
                <span style="margin-left: 5px;font-size: 14px;">个人中心</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="carousel-container">
        <swiper
          id="carousel-list"
          v-if="carouselList.length > 0"
          :options="swiperOption"
          ref="mySwiper"
          class="carousel-list">
            <swiper-slide  class="my-swp-silde" v-for="(slide, index) in carouselList" :key="index" data-id="slide.articleId" @click.native="goJumpLink(slide)">
                <img class="my-swp-img" :src="slide.rotationUrl" alt="">
                <div class="my-slide-name">{{slide.liveName}}</div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
      <div class="artical-container">
        <div class="artical-header">
          <div style="display: flex;">
            <div class="recommend" style="margin-right: 10px;display: flex;align-items: center;">
              <i class="icon iconfont iconwanshangcopy" style="color: #E71222;font-size: 30px!important;font-weight: bold;line-height: 30px;"></i>
              <span class="recommend-txt" style="margin-left:0;">直播|回放</span>
              <!-- <span class="recommend-txt" style="margin-left:0;" :class="tabIndex == 0 ? 'tabSelected' : ''" @click="changeTab(0)">直播|回放</span> -->
              <van-switch style="margin-left: 10px;" size="20px" v-model="tabIndex" active-color="#e3011b" inactive-color="#dcdee0" active-value="1" inactive-value="0" @change="changeTab"/>
            </div>
          </div>
          <div style="position: relative;">
            <div class="interest" @click="openFieldsList($event)">
              <i class="icon iconfont iconaixin" style="color: #E71222;font-size: 20px!important;font-weight: bold;line-height: 30px;"></i>
              <span class="interest-txt">兴趣</span>
            </div>
            <!-- 感兴趣的领域 -->
            <div class="indicationList" v-show="showFieldsList">
              <div style="text-align: center;margin-bottom: 5px;">筛选您感兴趣的领域</div>
              <ul>
                <!-- 暂时加此判断 隐藏心脑血管及代谢领域 -->
                <li v-for="(item, index) in fieldsList" :key="index" :class="{'active':item.checked}" @click="chooseFields(item)" :style="item.name=='心脑血管及代谢领域'?'display:none;':''">
                  {{item.name}}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="artical-list p_r" v-if="tabIndex == 0">
            <van-list
              class="vantList"
              v-if="totalArticleList.length > 0"
               style="z-index: 1;"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
            <div class="onLive-item" v-for="(item, index) in totalArticleList" :key="index">
              <img src="../../../assets/onLive/icon_onLive.png" style="width: 20%;position: absolute;right: 20%; top: 20%;z-index: 2;" alt="">
							<div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_speak.png" style="width: 16px" alt="">
									</div>
									<div class="f_w font16 NoWrap">{{item.liveName}}</div>
								</div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_date.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14">{{item.liveDate}}</div>
								</div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_time.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14">{{item.liveTime}}</div>
								</div>
								<div class="split_1_9 m_b_20">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_speaker.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14 NoWrap">{{item.speaker}}</div>
								</div>
								<div>
									<button class="btn_red font14 b_b" style="width: 80%;margin-left: 10%;padding: 6px" @click="goJumpLink(item)">参加</button>
								</div>
							</div>
            </div>
            </van-list>
          <div v-else style="text-align:center;margin-top: 50px;">
            {{noDataText}}
          </div>
        </div>

        <div class="artical-list p_r" v-else-if="tabIndex == 1">
            <van-list
              class="vantList"
              v-if="totalArticleList2.length > 0"
               style="z-index: 1;"
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad">
            <div class="onLive-item" v-for="(item, index) in totalArticleList2" :key="index">
              <img src="../../../assets/onLive/icon_onLive.png" style="width: 20%;position: absolute;right: 20%; top: 20%;z-index: 2;" alt="">
							<div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_speak.png" style="width: 16px" alt="">
									</div>
									<div class="f_w font16 NoWrap">{{item.liveName}}</div>
								</div>
                <div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_speaker.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14 NoWrap">{{item.speaker}}</div>
								</div>
								<div class="split_1_9 m_b_5">
									<div class="t_c">
										<img src="../../../assets/onLive/icon_date.png" style="width: 16px" alt="">
									</div>
									<div class="c_76B39D font14">{{item.validDate}}</div>
								</div>
	
								<div>
									<button class="btn_red font14 b_b" style="width: 80%;margin-left: 10%;padding: 6px" @click="goJumpRecordedLink(item)">收看录播</button>
								</div>
							</div>
            </div>
            </van-list>
          <div v-else style="text-align:center;margin-top: 50px;">
            {{noDataText}}
          </div>
        </div>
      </div>
    </div>
    <!--<div v-if="showGuide" class="guideTofollow"></div>-->
    <div v-if="showGuide" class="guideTofollowImg">
      <img src="../../../assets/guide_background_prod.png" />
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>
<script>
import agreeBookDialog from "../../login/agreeBookDialog";
import merge from 'webpack-merge';
import { List } from "vant"
import Switch from 'vant/lib/switch';
import 'vant/lib/switch/style';
import { swiper, swiperSlide } from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
export default {
  name: 'articalCollections',
  components: {
    swiper,
    agreeBookDialog,
    swiperSlide,
    [List.name]: List,
    [Switch.name]: Switch
    
  },
  data () {
    return {
      loading: true,
      ABDialogShow:false,
      finished: false,
      baseUrl: process.env.config.baseUrl,
      showPage: false,
      showHeadMenu: false,
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      takedacode: this.$route.query.takedacode || '',
      showGuide: false,
      userInfo: {},
      fieldsList: [],
      indicationList: [],
      showFieldsList: false,
      carouselList: [],
      articleList: [],
      totalArticleList: [],
      totalArticleList2: [],
      swiperOption: {
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      noDataText: '',
      pageIndex: 1,
      pageSize: 5,
      total: 0,
      totalPage: 0,
      skipcarouselCount: 0,
      containerHeight: 0,
      notList: false,
      tabIndex: 0,
    }
  },
  destroyed () {

  },
  created () {
    this.pageIndex = 1

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/mobileOnLive?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
 }

      //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
      if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      let url = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/mobileOnLive?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = url
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          let isEmployee = window.localStorage.getItem('isEmployee')
          let allAxiox = ''
          if (isEmployee) {
            let data = {
              openId: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
          } else {
            let data = {
              openid: this.openId,
              returnurl: encodeURIComponent(this.returnurl)
            }
            allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
          }


          if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}


          allAxiox.then(msg => {
            console.log(msg, 'getDoctor')
            if (msg.isSuccess) {
              if (!msg.data.isFollowed) {
                this.showGuide = true
                return
              }
              if (msg.data.status === 2) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else if (msg.data.status === 3) {
                //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
              } else {
                if (msg.data.isFollowed) {
                  this.showPage = true
                  // 获取用户信息
                  this.getUserInfo()
                } else {
                  this.showGuide = true
                }
              }
            }
          })
        })
      } else {
        this.openId = localStorage.openId
        let isEmployee = window.localStorage.getItem('isEmployee')
        let allAxiox = ''
        if (isEmployee) {
          let data = {
            openId: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getEmployee', data)
        } else {
          let data = {
            openid: this.openId,
            returnurl: encodeURIComponent(this.returnurl)
          }
          allAxiox = this.$axiox.postNoRes(process.env.config.baseUrl + '/api/wechat/getDoctor', data)
        }
        if(this.NewerTag=='NoHcp'){

this.$commonJs.mobileDoubleComfirm({
buttonType: "0",
type: "warning",
title: "提示",
content:
  "该平台仅供医疗卫生专业人士（HCP）使用，您已注册非HCP，暂无权限！",
successFun: () => {
},
errorFun: (err) => {},
});

}


        allAxiox.then(msg => {
          console.log(msg, 'getDoctor')
          if (msg.isSuccess) {
            if (!msg.data.isFollowed) {
              this.showGuide = true
              return
            }
            if (msg.data.status === 2) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else if (msg.data.status === 3) {
              //window.location.href = 'https://' + window.location.host + '/register?returnurl=' + encodeURIComponent((window.location.href || ''))
            } else {
              if (msg.data.isFollowed) {
                this.showPage = true
                // 获取用户信息
                this.getUserInfo()
              } else {
                this.showGuide = true
              }
            }
          }
        })
      }
    }

    setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);



  },
  mounted () {
    document.title = '武田直播'
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
         if(this.showGuide!=true){
          //name: "agreeBook",
          this.ABDialogShow = true
          }
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    onLoad () {
      if (this.tabIndex == 0) {
        if (this.total > this.totalArticleList.length) {
          this.loading = true
          this.pageIndex += 1
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields)
        } else {
          this.notList = true
          this.finished = true
        }
      } else if (this.tabIndex == 1) {
        if (this.total > this.totalArticleList2.length) {
          this.loading = true
          this.pageIndex += 1
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals2(this.userInfo.department, fields)
        } else {
          this.notList = true
          this.finished = true
        }
      }
    },
    toggleHeadMenu () {
      this.showHeadMenu = !this.showHeadMenu
    },
    searchHandler () {
      console.log(this.$route.query, 'query')
      let queries = this.$route.query
      this.$router.push({
        path: '/mobileOnLiveSearch',
        query: {
          skipcarouselCount: this.skipcarouselCount,
          fieldsList: JSON.stringify(this.fieldsList),
          ...queries
        }
      })
    },
    // 获取用户信息
    getUserInfo () {
      let isEmployee = window.localStorage.getItem('isEmployee')
      let requestUrl2 = ''
      if (isEmployee) {
        requestUrl2 = this.$axiox.getNoRes('/Login/EmployeeWxUserInfo?openId=' + this.openId)
      } else {
        let data = {
          openId: this.openId
        }
        requestUrl2 = this.$axiox.postNoRes('/Login/WxUserInfo', data)
      }
      requestUrl2.then(msg => {
        console.log(msg, 'msg')
        if (msg.isSuccess) {
          this.userInfo = msg.data
          // 获取领域
          if (msg.data.fields) {
            this.getFieldsList(msg.data.fields)
          } else {
            this.getFieldsList()
          }
        }
      })
    },
    // 获取领域
    getFieldsList (fields) {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        if (fields && fields.length > 0) {
          this.fieldsList = res.map(val => {
            return {
              checked: fields.some(v => v.name === val.name),
              ...val
            }
          })
          // 获取轮播图
          this.getCarouselArticles(this.userInfo.department, this.userInfo.fields)
        } else {
          this.fieldsList = res.map(val => {
            return {
              checked: false,
              ...val
            }
          })
          // 获取轮播图
          this.getCarouselArticles(this.userInfo.department, [])
        }
      })
    },
    chooseFields (item) {
      this.totalArticleList = []
      this.pageIndex = 1

      item.checked = !item.checked
      let fields = this.fieldsList.filter(val => val.checked)
      // 获取推荐轮播图
      this.getCarouselArticles(this.userInfo.department, fields)
    },
    openFieldsList (e) {
      e.stopPropagation();
      this.showFieldsList = !this.showFieldsList
    },
    // 获取轮播图
    getCarouselArticles (department, fields) {
      let fieldNames = fields.map(val => val.name)
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&Fields=' + item
      })
      console.log(str, 'str')
      let url = ''
      if (department || (fieldNames && fieldNames.length > 0)) {
        url = `/api/Live/mobile/live/rotation/list`
      } else {
        url = `/api/Live/mobile/live/rotation/list`
      }
      this.$axiox.get('/api/Live/mobile/live/rotation/list').then(res => {
        console.log(res, 'Carousel')
          this.carouselList = res || []
        // 获取推荐文章
        let fields = this.fieldsList.filter(val => val.checked)
        this.getArticals(this.userInfo.department, fields)
        this.swiperOption.autoplay = {
          delay: 2000, // 轮播图时长
          stopOnLastSlide: false,
          disableOnInteraction: false
        }
        // this.$nextTick(() => {
        //   setTimeout(t => {
        //     let swiperDom = document.getElementById('carousel-list')
        //     console.log(swiperDom.offsetHeight, 'offsetHeight')
        //     this.containerHeight = swiperDom.offsetHeight - 60
        //   }, 300)
        // })
      })
    },
    // 获取推荐文章
    getArticals (department, fields) {
      console.log(department, fields, 'department, fields')
      this.notList = false
      this.finished = false
      let thisFields = fields.map(val => val.name)
      let fieldNames = fields.map(val => val.name)
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&Fields=' + item
      })
      console.log(str, 'str')
      // let url = ''
      // if ((fieldNames && fieldNames.length > 0)) {
      //   url = `/api/Live/mobile/live/list?LiveName=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}` + str
      // } else {
      //   url = `/api/Live/mobile/live/list?keywords=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      // }
			let data = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			}
      this.$axiox.getList(this.$commonJs.returnQuery('/api/Live/mobile/live/list', data) + str).then(res => {
        console.log(res, 'getArticals')
        setTimeout(() => {
          this.loading = false
        }, 500)
        if (res.data && res.data.length > 0) {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList.push(res.data[i])
          }
          this.total = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList.push(res.data[i])
          }
          this.total = 0
          this.totalPage = 0
          this.noDataText = '更多精彩内容，敬请期待！'
        }
      })
    },
    getArticals2 (department, fields) {
      console.log(department, fields, 'department, fields')
      this.notList = false
      this.finished = false
      let thisFields = fields.map(val => val.name)
      let fieldNames = fields.map(val => val.name)
      let str = ''
      fieldNames.forEach(item => {
        str = str + '&Fields=' + item
      })
      console.log(str, 'str')
      // let url = ''
      // if ((fieldNames && fieldNames.length > 0)) {
      //   url = `/api/Live/mobile/live/list?LiveName=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}` + str
      // } else {
      //   url = `/api/Live/mobile/live/list?keywords=${''}&skipcarouselCount=${this.skipcarouselCount}&pageIndex=${this.pageIndex}&pageSize=${this.pageSize}`
      // }
			let data = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
			}
      this.$axiox.getList(this.$commonJs.returnQuery('/api/Live/mobile/recordedLive/list', data) + str).then(res => {
        console.log(res, 'getArticals')
        setTimeout(() => {
          this.loading = false
        }, 500)
        if (res.data && res.data.length > 0) {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList2.push(res.data[i])
          }
          this.total = res.total
          this.totalPage = Math.ceil(res.total / this.pageSize)
        } else {
          for(let i = 0; i < res.data.length; i++) {
            this.totalArticleList2.push(res.data[i])
          }
          this.total = 0
          this.totalPage = 0
          this.noDataText = '更多精彩内容，敬请期待！'
        }
      })
    },
    // 去收藏页
    goFavoritesPage () {
      let queries = this.$route.query
      queries.from = 'articalCollections'
      // queries.returnurl = encodeURIComponent(window.location.href)
      this.$router.push({
        path: '/favConList',
        query: queries
      })
    },
    // 去个人中心
    goPersonalPage () {
      // let queries = this.$route.query
      // queries.from = 'articalCollections'
      // // queries.returnurl = encodeURIComponent(window.location.href)
      // this.$router.push({
      //   path: '/register',
      //   query: queries
      // })
      window.location.href = process.env.config.vcPersonalCenter
    },
    goJumpLink (slide) {
			let data = {
				liveName: slide.liveName,
				openId: this.openId,
				liveUrl: slide.liveUrl,
				liveId: slide.id
			}
			this.$axiox.post('/api/Live/mobile/log', data).then( p => {
        if (slide.liveUrl){
          if(slide.liveUrl.indexOf('?') >= 0){
            window.location.href = `${slide.liveUrl}&AttendType=WY`
          } else {
            window.location.href = `${slide.liveUrl}?AttendType=WY`
          }
          // window.location.href = slide.liveUrl
        }
			} )
    },
    goJumpRecordedLink (slide) {
			let data = {
				liveName: slide.liveName,
				openId: this.openId,
				liveUrl: slide.recordLiveUrl,
				liveId: slide.id
			}
			this.$axiox.post('/api/Live/mobile/log', data).then( p => {
        if (slide.recordLiveUrl){
          if(slide.recordLiveUrl.indexOf('?') >= 0){
            window.location.href = `${slide.recordLiveUrl}&AttendType=WY&bcemail=${data.openId}&bctrackingid=${data.openId}&bccustomguid=${data.openId}`
          } else {
            window.location.href = `${slide.recordLiveUrl}?AttendType=WY&bcemail=${data.openId}&bctrackingid=${data.openId}&bccustomguid=${data.openId}`
          }
          // window.location.href = slide.liveUrl
        }
			} )
    },
    needReflash () {
      if (this.tabIndex == 0) {
        this.pageIndex = 1
        let fields = this.fieldsList.filter(val => val.checked)
        this.getArticals(this.userInfo.department, fields)
      } else if (this.tabIndex == 1) {
        this.pageIndex = 1
        let fields = this.fieldsList.filter(val => val.checked)
        this.getArticals2(this.userInfo.department, fields)
      }
    },
    getNextPage () {
      if (this.tabIndex == 0) {
        if (this.total > this.totalArticleList.length) {
          this.pageIndex += 1
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals(this.userInfo.department, fields)
        } else {
          this.notList = true
          this.finished = true
        }
      } else if (this.tabIndex == 1) {
        if (this.total > this.totalArticleList2.length) {
          this.pageIndex += 1
          let fields = this.fieldsList.filter(val => val.checked)
          this.getArticals2(this.userInfo.department, fields)
        } else {
          this.notList = true
          this.finished = true
        }
      }
    },
    scrollHandler () {
      var scrollTop = document.documentElement.scrollTop // 滚动条的位置
      var windowHeitht = document.documentElement.clientHeight // 在页面上返回内容的可视高度
      var scrollHeight = document.documentElement.scrollHeight // 返回整个元素的高度（包括带滚动条的隐蔽的地方）
      // 是否滚动到底部的判断
      if (scrollHeight - windowHeitht - scrollTop < 40) {
        console.log('滚到底了')
        alert('翻页' + this.pageIndex)
        // 页数加1
        // this.pageIndex += 1
        if (this.pageIndex <= this.totalPage) {
          this.pageIndex += 1
          // 获取推荐文章
          let fields = this.fieldsList.filter(val => val.checked)
          if (this.tabIndex == 0) {
            this.getArticals(this.userInfo.department, fields)
          } else if (this.tabIndex == 1) {
            this.getArticals2(this.userInfo.department, fields)
          }
        } else {
          this.notList = true
          this.finished = true
          return
        }
      }
    },
    changeTab (tabIndex) {
      this.tabIndex = tabIndex;
      this.pageIndex = 1;
      this.totalArticleList = [];
      this.totalArticleList2 = [];

      // 获取推荐文章
      let fields = this.fieldsList.filter(val => val.checked)
      if (this.tabIndex == 0) {
        this.getArticals(this.userInfo.department, fields)
      } else if (this.tabIndex == 1) {
        this.getArticals2(this.userInfo.department, fields)
      }
    }
  },
  computed: {
    swiper() {
      this.$nextTick(() => {
        return this.$refs.mySwiper.swiper;
      })
    }
  },
}
</script>
<style scoped>
  #articalCollections {
    width: 100%;
  }
  .top-header {
    width: 100%;
    height: 60px;
  }
  .header-bg {
    width: 100%;
    height: 90px;
    background-color: #FF4D4F;
    border-radius: 0px 0px 45px 45px;
    display: flex;
    flex-direction: row;
    padding: 15px 20px;
    box-sizing: border-box;
    justify-content: space-around;
    padding-right: 0;
  }
  .search {
    width: 250px;
    height: 35px;
    position: relative;
  }
  .searchBar {
    width: 250px;
    height: 35px;
    line-height: 35px;
    border: none;
    border-radius: 30px;
    background-color: #E71222;
    box-sizing: border-box;
    color: #ffffff;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .search-icon {
    color: #ffffff;
    position: absolute;
    left: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .empty-icon {
    color: #ffffff;
    position: absolute;
    right: 3px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 27px!important;
    font-weight: bold;
  }
  .top-menu {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    background-color: #E71222;
    text-align: center;
    box-shadow: 0px 2px 6px -2px rgba(0, 0, 0, 0.4);
    position: relative;
  }
  .top-menu-active {
    background-color: #ffffff;
  }
  .top-menu-list {
    width: 100px;
    background-color: #FFFFFF;
    padding: 15px 5px;
    border-radius: 10px;
    position: absolute;
    right: 22px;
    top: 28px;
    z-index: 2;
    box-shadow: 0px 0px 6px -2px rgba(0, 0, 0, 0.4);
  }
  .menu-icon {
    color: #ffffff;
    line-height: 35px;
  }
  .menu-icon-active {
    color: #E71222;
  }
  .carousel-container {
    width: 90%;
    /* height: 160px; */
    /*height: 100px;*/
    margin: 0 auto;
    position: relative;
  }
  .carousel-list {
    width: 100%;
    /* height: 220px; */
    margin: 0 auto;
    border-radius: 15px;
  }
  .my-swp-silde {
    width: 100%;
    position: relative;
  }
  .my-swp-silde .my-swp-img {
    display: block;
    width: 100%;
    height: 100%;
  }
  .swiper-pagination >>> .swiper-pagination-bullet-active {
    background: #EF1201!important;
  }
  .my-slide-name {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    background-color: rgba(255,255,255, 0.5);
    color: #333333;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .artical-container {
    width: 100%;
    background-color: #FBFBFB;
    border-radius: 45px 45px 0px 0px;
    /* min-height: 502px; */
    /* min-height: 488px; */
		min-height: calc(100vh - 202px);
    padding-bottom: 50px;
    padding-top: 45px;
    /* margin-top: -20px; */
    position: relative;
    z-index: 0;
		box-sizing: border-box;
  }
  .artical-header {
    width: 90%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  .recommend,
  .interest {
    height: 30px;
    box-sizing: border-box;
  }
  .interest {
    border-radius: 20px;
    border: 1px solid #E71222;
    padding: 0 15px;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.4);
  }
  .recommend-txt,
  .interest-txt {
    color: rgb(16, 16, 16);
    font-size: 16px;
    text-align: left;
    font-family: SourceHanSansSC-regular;
    line-height: 30px;
    margin-left: 5px;
  }
  .interest-txt {
    color: #E71222;
  }
  .artical-list {
    width: 90%;
    margin: 0 auto;
  }
	.onLive-item {
		position: relative;
	}
  .onLive-item > div{
    width: 100%;
    margin-bottom: 20px;
		background-color: #FFFFFF;
		padding: 12px;
		box-sizing: border-box;
		border-radius: 15px 0px 0px 38px;
		position: relative;
		z-index: 1;
  }
	  .onLive-item::after{
			content: '';
			display: block;
			width: 100%;
			height: 100%;
			position: absolute;
			top: 8px;
			left: 4px;
			border-radius: 15px 0px 0px 38px;
			background-color: #F8CDC0;
		}

  .colorful-boder {
    min-height: 40px;
    width: 10px;
    border-radius: 15px;
    background-image: linear-gradient(to bottom, #E71222, #FBAEA6);
  }
  .right {
    padding: 5px 7px;
  }
  .right .item-info-title {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
  }
  .right .item-info-read {

  }
  .right .item-info-read .num {
    /* color: rgb(192,192,192); */
    color: rgb(137,137,137);
    font-size: 12px;
    margin-right: 5px;
  }
  .indicationList {
    width: 170px;
    /* height: 120px;
    min-height: 120px; */
    position: absolute;
    top: 35px;
    right: 0px;
    padding: 15px;
    background: rgba(255,255,255, 0.8);
    border-radius: 10px;
    border: 1px solid #C5C5C5;
    overflow: auto;
    z-index: 3;
  }
  .indicationList ul {
    width: 100%;
    margin: 0 auto;
  }
  .indicationList ul li {
    width: 100%;
    /* height: 30px; */
    height: auto;
    /* line-height: 30px; */
    background-color: #ffffff;
    border: 1px solid #C5C5C5;
    color: #666666;
    box-sizing: border-box;
    text-align: center;
    border-radius: 4px;
    margin-top: 15px;
    padding: 5px 0;
  }
  .indicationList ul li.active {
    color: #EF1201;
    border: 1px solid #EF1201;
  }
  .vantList >>> .van-loading__spinner.van-loading__spinner--circular{
    display: none;
  }
  .vantList >>> .van-list__finished-text{
    text-align:center;
    color:rgb(137,137,137);
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/mobileOnLive/mobileOnLive.vue